import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonChamiliKentimata';
const args = {};

export class OligonChamiliKentimata extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
